var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c("div", { staticClass: "bgheader" }, [
      _c(
        "nav",
        { staticClass: "d-flex flex-row justify-start align-center py-2 px-8" },
        [
          _c(
            "v-flex",
            {
              staticClass: "d-none d-sm-flex flex-row px-2 flex-shrink-0",
              attrs: { xs3: "" }
            },
            [
              _c("div", { staticClass: "logoSize" }, [
                _vm.electionLogo
                  ? _c("input", {
                      staticClass: "logoSize",
                      attrs: {
                        type: "image",
                        src: _vm.electionLogo,
                        title: "Logotipo da eleição"
                      }
                    })
                  : _vm._e()
              ])
            ]
          ),
          _c(
            "v-flex",
            {
              staticClass:
                "d-flex flex-row px-2 flex-shrink-0 align-items-center justify-center",
              attrs: { xs12: "", sm6: "" }
            },
            [
              _c(
                "h1",
                { class: _vm.$vuetify.theme.dark ? "font_dark" : "font_white" },
                [
                  _vm._v(" " + _vm._s(this.$store.state.election.name) + " "),
                  _c("span", { staticClass: "voterNameMenu" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$store.state.login.voterName
                          ? " - " + _vm.$store.state.login.voterName
                          : ""
                      )
                    )
                  ])
                ]
              )
            ]
          ),
          _vm.isAuthenticated && !_vm.isAuthenticated
            ? _c(
                "v-flex",
                { staticClass: "d-flex align-items-center justify-start" },
                [
                  _vm._l(_vm.items, function(item, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "d-flex align-items-center px-2" },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "d-flex flex-column align-items-center justify-start px-2 secondary--text",
                            attrs: { href: item.to }
                          },
                          [
                            _c("v-icon", {
                              staticClass: "white--text",
                              domProps: { textContent: _vm._s(item.icon) }
                            }),
                            _c("span", { staticClass: "white--text" }, [
                              _vm._v(_vm._s(item.title))
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex\n          align-items-center\n          justify-center\n          px-2"
                    },
                    [
                      _c("p", { staticClass: "secondary--text px-2 ma-0" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$store.state.login.voterName) + " "
                        )
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "error",
                          attrs: { elevation: "0" },
                          on: { click: _vm.logout }
                        },
                        [
                          _c("span", { staticClass: "white--text" }, [
                            _vm._v("Sair")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.accessibilityActivated
            ? _c(
                "v-flex",
                {
                  staticClass:
                    "d-none d-sm-flex flex-row align-items-center justify-end px-2 flex-shrink-0",
                  attrs: { xs3: "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2 rounded-btn",
                      attrs: { color: "background", elevation: "0" },
                      on: { click: _vm.fontReset }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "text", attrs: { small: "" } },
                        [_vm._v(" mdi-reload ")]
                      ),
                      _c("span", { staticClass: "accessible" }, [
                        _vm._v("Resetar fonte")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2 rounded-btn",
                      attrs: { color: "background", elevation: "0" },
                      on: { click: _vm.fontResizeMinus }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "text", attrs: { small: "" } },
                        [_vm._v(" mdi-minus ")]
                      ),
                      _c("span", { staticClass: "accessible" }, [
                        _vm._v("Diminuir fonte")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2 rounded-btn",
                      attrs: { color: "background", elevation: "0" },
                      on: { click: _vm.fontResizePlus }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "text", attrs: { small: "" } },
                        [_vm._v(" mdi-plus ")]
                      ),
                      _c("span", { staticClass: "accessible" }, [
                        _vm._v("Aumentar fonte")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2 rounded-btn",
                      attrs: { color: "background", elevation: "0" },
                      on: { click: _vm.darkMode }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "text", attrs: { small: "" } },
                        [_vm._v(" mdi-eye ")]
                      ),
                      _c("span", { staticClass: "accessible" }, [
                        _vm._v("Contraste")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]),
    this.$store.state.showAlertManyVotes
      ? _c("div", [
          _c(
            "nav",
            {
              staticClass:
                "d-flex flex-row justify-start align-center py-2 px-8"
            },
            [
              _c("v-flex", {
                staticClass: "d-none d-sm-flex flex-row px-2 flex-shrink-0",
                attrs: { xs1: "" }
              }),
              _c(
                "v-flex",
                {
                  staticClass:
                    "d-flex flex-row px-2 flex-shrink-0 align-items-center justify-center",
                  attrs: { xs12: "", sm10: "" }
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "alertManyVotes align-center" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "2" } },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "custom-icon warning--text" },
                            [_vm._v(" mdi-alert-outline ")]
                          )
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "10" } }, [
                        _c("p", {
                          domProps: { innerHTML: _vm._s(_vm.msgAlert) }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.isAuthenticated && !_vm.isAuthenticated
                ? _c("v-flex", {
                    staticClass: "d-flex align-items-center justify-start"
                  })
                : _vm._e(),
              _vm.accessibilityActivated
                ? _c("v-flex", {
                    staticClass:
                      "d-none d-sm-flex flex-row align-items-center justify-end px-2 flex-shrink-0",
                    attrs: { xs1: "" }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }